import React, { useEffect } from 'react'
import { Transition } from 'react-transition-group'
import { classNames } from 'core/helpers/misc'
import { Button } from 'core/components/button'
import { ModalPortal } from './ModalPortal'

export const ModalForm = ({
	children,
	show,
	title,
	fetching,
	submitting,
	submitText = 'Salvar',
	submitIcon = 'fas fa-save',
	isLarge,
	onSubmit,
	closeAction,
	resetForm = () => {},
}) => {
	useEffect(() => {
		if (!show) setTimeout(resetForm, 300)
		// eslint-disable-next-line
	}, [show])

	return (
		<ModalPortal>
			<Transition in={show} timeout={300}>
				{status => (
					<>
						<div
							aria-modal="true"
							className={classNames('modal fade', {
								show: status === 'entered',
							})}
							role="dialog"
							style={{
								display: status === 'exited' ? 'none' : 'block',
							}}
							tabIndex={-1}
						>
							<div
								className={classNames('modal-dialog modal-dialog-centered', {
									'modal-lg': isLarge,
								})}
								role="document"
							>
								<div className="modal-content">
									<form
										onSubmit={ev => {
											ev.preventDefault()
											if (onSubmit) onSubmit(ev)
										}}
									>
										<div className="modal-header">
											<h5 className="modal-title">{title}</h5>

											<Button
												aria-label="close"
												className="close"
												data-dismiss="modal"
												onClick={closeAction}
												type="button"
											/>
										</div>
										<div className="modal-body">
											{fetching ? (
												<div className="spinner">
													<span
														aria-hidden="true"
														className="spinner-border spinner-border-sm"
														role="status"
													/>
													<span>Carregando...</span>
												</div>
											) : (
												children
											)}
										</div>

										<div className="modal-footer">
											<Button
												customClassName="btn-secondary"
												icon="fas fa-arrow-left"
												onClick={closeAction}
												title="Voltar"
												type="button"
											/>

											{!fetching && (
												<Button
													customClassName="btn-primary"
													disabled={submitting}
													icon={submitIcon}
													loading={submitting}
													title={submitText}
												/>
											)}
										</div>
									</form>
								</div>
							</div>
						</div>

						{status !== 'exited' && (
							<div
								className={classNames('modal-backdrop fade', {
									show: status === 'entered',
								})}
							/>
						)}
					</>
				)}
			</Transition>
		</ModalPortal>
	)
}
